<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="!!data">
    <InputBasic
        v-model="data"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";

import QuestionBase from "../../../QuestionBase";
import InputBasic from "../../../inputs/InputBasic";

export default {
  name: 'RetirementAge',
  mixins: [questionLoadHelpers],
  components: {
    InputBasic,
    QuestionBase
  },
  props: {
    value: {
      type: Number,
      required: false
    },
    saveLocation: {
      type: String,
      default: 'client_client'
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'When do you expect to retire?',
        subTitle:  'The state retirement age for men is 67, for women it is 65',
        tip: null
      },
      db: {
        saveLocation: this.saveLocation,
        saveField: 'profileRetirementAge'
      },
      args: {
        placeholder: '67',
        label: null,
        type: 'number',
        skippable: false,
        required: true,
        inputClass: 'field-50',
        appendText: 'Years Old'

      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
